module.exports = __webpack_public_path__ + "img/webgl-indicator.3cfc5f4f.svg";